import { useRef } from "react";
import {
  motion,
  useMotionValue,
  useTransform,
  useAnimationFrame,
} from "framer-motion";

const wrap = (min, max, v) => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

function ParallaxText({ children, baseVelocity = 100 }) {
  const baseX = useMotionValue(0);

  const x = useTransform(baseX, (v) => `${wrap(-20, -45, v)}%`);

  useAnimationFrame((t, delta) => {
    // Always left to right only - positive moveBy
    let moveBy = baseVelocity * (delta / 1000);
    baseX.set(baseX.get() + moveBy);
  });

  return (
    <div className="overflow-hidden m-0 whitespace-nowrap flex flex-nowrap">
      <motion.div
        className="font-serif text-[13px] md:text-sm font-medium tracking-[0.15em] flex flex-nowrap whitespace-nowrap"
        style={{ x }}
      >
        {[...Array(8)].map((_, i) => (
          <span key={i} className="block mr-12 md:mr-16">{children}</span>
        ))}
      </motion.div>
    </div>
  );
}

export default function TopBanner({ isHome = false }) {
  const containerClasses = isHome 
    ? "absolute top-0 left-0 w-full bg-transparent text-white py-2 overflow-hidden z-50"
    : "relative bg-gradient-to-r from-rose-50 via-pink-50 to-rose-50 text-gray-900 py-2 overflow-hidden z-50 border-b border-rose-100/50";

  return (
    <div 
      className={containerClasses}
      role="region"
      aria-label="Promotional Banner"
    >
      {!isHome && (
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-50 pointer-events-none" />
      )}
      <ParallaxText baseVelocity={0.5}>
        <span className={`font-bold uppercase text-[10px] md:text-[11px] ${!isHome ? 'normal-case text-xs md:text-sm tracking-normal' : ''}`}>Welcome to Sera  -  Handcrafted with Love  -  Free Shipping on Orders Above INR 999.</span>
      </ParallaxText>
    </div>
  );
}
